import {
	loaderStart,
	loaderStop,
	getCartSuccess,
	getFinalInstructions,
	clearState,
} from './slices'
import Api from 'utils/api'
import { showPopup } from 'components/Modal/slices'
import { setItemsAsHandled } from 'components/Footer/slices'
import { getIsComplaintRequestData } from '../../utils/common'

export const getCartFinal = (requestData = {}) => async (dispatch) => {
	try {
		dispatch(loaderStart())
		/**/
		Api.post(
			'/cart',
			getIsComplaintRequestData(requestData, 'hasItemsForComplaint')
		)
			.then((res) => dispatch(getCartSuccess(res)))
			.then((res) => {
				let {
					shippingOptionId = '',
					language,
					shopId,
					isComplaint = false,
				} = getIsComplaintRequestData(requestData)
				let { payload = {} } = res
				let { preApproval = false } = payload

				Api.get(
					`/faqs/${shopId}/language/${language}/cart-final?shippingOptionId=${shippingOptionId}&shippingLabelFailed=false&preApproval=${preApproval}&isComplaint=${isComplaint}`
				)
					.then((res) => {
						dispatch(getFinalInstructions(res))
						dispatch(setItemsAsHandled(true))
					})
					.catch((error) => {
						dispatch(loaderStop())
						dispatch(showPopup(error))
					})
			})
			.catch((error) => {
				dispatch(loaderStop())
				dispatch(showPopup(error))
			})
	} catch (error) {
		dispatch(loaderStop())
	}
}

export const setRefundStateToDefault = (requestData = {}) => async (
	dispatch
) => {
	try {
		dispatch(clearState())
	} catch (error) {
		dispatch(loaderStop())
	}
}
